import { createContext, FC, ReactNode, useContext, useMemo } from 'react';

import { useParams } from 'react-router-dom';

import { Permission } from '../../../backend/src/auth/permissions/permission';
import { useGetMatterV2 } from '@/api/queries/useGetMatterV2';

interface MatterPermissionContextType {
  /** The requesting user's effective permissions for this matter (with overrides applied). */
  effectivePermissions: Permission[] | null;
}

const MatterPermissionContext = createContext<MatterPermissionContextType>({ effectivePermissions: null });

export function useMatterPermissions(): MatterPermissionContextType {
  return useContext(MatterPermissionContext);
}

export const MatterPermissionProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const { matterId } = useParams<{ matterId: string }>();
  const { data: matter } = useGetMatterV2(matterId);

  const value = useMemo<MatterPermissionContextType>(
    () => ({ effectivePermissions: matter?.effectivePermissions ?? null }),
    [matter?.effectivePermissions],
  );

  return <MatterPermissionContext.Provider value={value}>{children}</MatterPermissionContext.Provider>;
};
